import * as React from "react";
const Fabriek = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.023 1.563c0-.12-.13-.194-.232-.134L2.198 8.203a.15.15 0 0 0-.077.133v6.74h9.122V8.775a.463.463 0 0 1 .927 0v6.3h1.853zM1.194 8.336v6.74h-.73a.463.463 0 0 0 0 .926h15.073a.463.463 0 1 0 0-.926h-.587V1.563c0-.835-.906-1.355-1.627-.934L1.73 7.403c-.332.194-.536.55-.536.933m3.202 1.777a.463.463 0 0 0 0 .927h3.892a.463.463 0 1 0 0-.927zm-.535 2.986c0-.256.207-.463.463-.463h3.892a.463.463 0 1 1 0 .926H4.324a.463.463 0 0 1-.463-.463"
      fill="#000"
    />
  </svg>
);
export default Fabriek;
